import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IMainOptions {
  isSmall: boolean
}

interface IViewOptionsState {
  main: IMainOptions
}

const initialState: IViewOptionsState = {
  main: {
    isSmall: true
  }
}

export const viewOptionsSlice = createSlice({
  name: 'viewOptions',
  initialState,
  reducers: {
    setMainIsSmall(state, action: PayloadAction<boolean>) {
      state.main.isSmall = action.payload
    }
  }
  // extraReducers: (builder) => {
  //   builder.addMatcher(modalActions.onShowModal.match, (state, {payload}) => {
  //     if (!payload) {
  //       state.period = initialState.period
  //       state.selectedPeriods = initialState.selectedPeriods
  //       state.doRemovePeriods = initialState.doRemovePeriods
  //       state.employee = initialState.employee
  //       state.project = initialState.project
  //       state.projectManager = initialState.projectManager
  //     }
  //
  //   })
  // }
})

export const viewOptionsActions = viewOptionsSlice.actions
export const viewOptionsReducer = viewOptionsSlice.reducer
